import { makeStyles } from '@material-ui/core/styles'

const drawerWidth = 256
const marginTopContent = 24
const toolbarHeight = 94
const toolbarMobile = 128


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex'
  },
  appBar: {
    width: '100%',
    marginTop: marginTopContent,
    height: toolbarHeight,
    right: 'auto',
    boxShadow: 'none',
    zIndex: 3,
    [theme.breakpoints.up('xs')]: {
      maxWidth: 328,
      height: toolbarHeight + 20
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: '100%',
      width: '100%'
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
      width: '100%'
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '100%',
      width: '100%',
      height: toolbarHeight
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 1280,
      height: toolbarHeight
    }
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerPaper: {
    width: drawerWidth,
    padding: '32px 8px 8px 8px',
    borderRight: 'none',
    borderRadius: 0,
    flexDirection: 'column',
    display: 'flex',
    backgroundColor: theme.palette.text.primary,
    justifyContent: 'space-between',
    overflowX: 'hidden'
  },
  toolbar: (props) => ({
    // marginBottom: marginBottomContent,
    height: props.isDesktop ? toolbarHeight : toolbarMobile,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    ...theme.mixins.toolbar
  }),
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.up('xs')]: {
      maxWidth: 328,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: '100%',
      width: '100%',
      marginLeft: 15,
      marginRight: 15
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
      width: '100%',
      marginLeft: 48,
      marginRight: 48
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '100%',
      width: '100%',
      marginLeft: 60,
      marginRight: 60
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 1280,
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    // width: `calc(100% - ${drawerWidth}px)`
  },
  drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: 80,
    [theme.breakpoints.up('sm')]: {
      width: 80,
    },
  },
  openSidebarBadge: {
    width: 32,
    height: 32,
    position: 'fixed',
    top: 44,
    left: 80,
    backgroundColor: theme.palette.divider,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0px 8px 8px 0px',
    cursor: 'pointer'
  }
}))

export default useStyles
